import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  translateObject: {[key: string]: string} = {};

  constructor(
    private http: HttpClient
  ) { }

  translate(lang: string = 'en'): Observable<{}> {
    const path = `assets/locales/${lang}.json`;

    return this.http.get(path).pipe(
      map( (res: {[key: string]: string}) => this.translateObject = res ),
      catchError(error => {
        return this.translate(lang.length > 2 ? lang.slice(0, 2) : 'en');
      })
    );
  }

  get(key: string): any {
    return this.translateObject[key];
  }
}
